module.exports = __webpack_public_path__ + "img/00022.f217625f.webp";